import styled from "styled-components";

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  /* Soft Light Blue Gradient */
  background: linear-gradient(135deg, #eaf1ff, #c8d9ff);

  font-family: "Inter", Arial, sans-serif;

  /* Card Styling Inside Wrapper */
  .auth-card {
    width: 90%;
    max-width: 360px;
    background: #ffffff;
    padding: 32px 24px;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
    text-align: center;
    animation: fadeIn 0.5s ease-out;
  }

  /* Icon Box */
  .iconBox {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: #e8f0fe;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px auto;
  }

  /* Title */
  .title {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin-top: 10px;
  }

  /* Subtitle */
  .subtitle {
    font-size: 14px;
    color: #6b7280;
    margin-top: 4px;
  }

  /* Loader */
  .loader {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 3px solid #e5e7eb;
    border-top-color: #1d4ed8;
    animation: spin 0.8s linear infinite;
    margin: 20px auto;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Fade-in Animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .dots-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 16px 0;
}

.dots-loader span {
  width: 8px;
  height: 8px;
  background: #ec0986ff;
  border-radius: 50%;
  animation: dotBlink 0.8s infinite ease-in-out;
}

.dots-loader span:nth-child(2) { animation-delay: 0.2s; }
.dots-loader span:nth-child(3) { animation-delay: 0.4s; }

@keyframes dotBlink {
  0% { opacity: 0.3; transform: translateY(0); }
  50% { opacity: 1; transform: translateY(-4px); }
  100% { opacity: 0.3; transform: translateY(0); }
}

`;

export default Wrapper;
